import React from 'react';
import { Flex } from '../../../../components/UI-CHAKRA/Flex';
import { FONT_ONEST } from '../constants';
import { SncrPrescriptionTypeConfig } from '../types';

interface PrescriptionTypeTagProps {
  config: SncrPrescriptionTypeConfig;
}

export function PrescriptionTypeTag({ config }: PrescriptionTypeTagProps) {
  return (
    <Flex
      bg={config.tag.bg}
      color={config.tag.color}
      border={config.tag.border ? `1px solid ${config.tag.border}` : undefined}
      borderRadius="6px"
      width="36px"
      height="20px"
      alignItems="center"
      justifyContent="center"
      fontSize="10px"
      fontWeight={700}
      fontFamily={FONT_ONEST}
      lineHeight="1"
      flexShrink={0}
    >
      {config.id}
    </Flex>
  );
}
